module.exports = __webpack_public_path__ + "img/rp.e69ee669.svg";